export default {
  // customized state variables

  bookingServices: [],
  fetchedBookingServices: false,

  coaches: [],
}